import { Button, withStyles } from '@material-ui/core';

import { getColorTheme } from '~/src/dash/resellers/utils/importResellerConfig';

export const ModelMediumButtonStyle = {
  height: '50px',
  background: getColorTheme('primaryButton'), // Background color of big buttons
  boxShadow: '0px 0px 6px' + getColorTheme('primaryButtonShadow'), // Shadow color of big buttons
  color: '#fafafa',
  '&:hover': {
    background: getColorTheme('primaryButtonHovered'), // Background color of big buttons when hovered
  },
  '&:active': {
    background: getColorTheme('primaryButtonActive'), // Background color of big buttons when active
    boxShadow: 'none',
  },
  '&:disabled': {
    background: getColorTheme('primaryButtonDisabled'), // Background color of big buttons when disabled
    boxShadow: 'none',
  },
  label: {
    '&$disabled': {
      color: '#B3B3B4 !important',
    },
  },
  '&.Mui-disabled': {
    background: getColorTheme('primaryButtonDisabled'), // Background color of big buttons when disabled
    boxShadow: 'none',
  },
};

export const ModelSmallButtonStyle = {
  height: '40px',
  background: getColorTheme('primaryButton'), // Background color of big buttons
  boxShadow: '0px 0px 6px' + getColorTheme('primaryButtonShadow'), // Shadow color of big buttons
  color: '#fafafa',
  '&:hover': {
    background: getColorTheme('primaryButtonHovered'), // Background color of big buttons when hovered
  },
  '&:active': {
    background: getColorTheme('primaryButtonActive'), // Background color of big buttons when active
    boxShadow: 'none',
  },
  '&:disabled': {
    background: getColorTheme('primaryButtonDisabled'), // Background color of big buttons when disabled
    boxShadow: 'none',
  },
  label: {
    '&$disabled': {
      color: '#B3B3B4 !important',
    },
  },
  '&.Mui-disabled': {
    background: getColorTheme('primaryButtonDisabled'), // Background color of big buttons when disabled
    boxShadow: 'none',
  },
};

export const ModelMediumButton = (
  withStyles({
    root: ModelMediumButtonStyle,
  }) as any
)(Button);

export const ModelSmallButton = (
  withStyles({
    root: ModelSmallButtonStyle,
  }) as any
)(Button);
